import React, { useEffect, useState } from "react";
import CardHeadMenu from "../Components/Card/CardHeadMenu/CardHeadMenu";
import { useSelector } from "react-redux";
import LeaveCard from "./LeaveCard";
import configServ from "../services/config";
import LeaveTable from "./LeaveTable";

const LeavePage = () => {
  const { company_id, is_super, is_admin, permissions } = useSelector(
    (state) => state.GlobalVariables,
  );
  const [isCreate, setIsCreate] = useState(false);

  const [isEdit, setIsEdit] = useState(false);

  const [editData, setEditData] = useState({});
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [leaveList, setLeaveList] = useState([]);
  const [ischange, setIschange] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  useEffect(() => {
    //     fetchSalesOrderList();
    scrollToTop();
  }, []);
  const handlePopup = () => {
    if (isCreate === true) {
      clear();
    }
    setIsCreate(!isCreate);
    setIsEdit(false);
  };

  const clear = () => {
    setEditData({});
  };

  const fetchLeaveTypes = async () => {
    try {
      const response = await configServ.getleaveTypes();

      if (response?.status) {
        setLeaveTypes(response?.data);
      } else {
        setLeaveTypes([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchGlobalLeave = async () => {
    try {
      const response = await configServ.getActiveGlobalHolidays(company_id);

      if (response?.status) {
        setLeaveList(response?.data);
      } else {
        setLeaveList([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (isCreate) {
      fetchLeaveTypes();
      fetchGlobalLeave();
    }
  }, [isCreate]);

  const handleEdit = (row) => {
    setEditData(row);
    setIsEdit(true);
    setIsCreate(true);
    scrollToTop();
  };
  return (
    <>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Leave Management"}
        handlePopup={handlePopup}
        isEdit={isEdit}
        create={isCreate}
        showCreate={Boolean(is_super || is_admin || permissions?.includes(80))}
      />

      {isCreate && (
        <LeaveCard
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          editData={editData}
          clear={clear}
          isCreate={isCreate} // State passed as a prop
          setIsCreate={setIsCreate} // Function passed as a prop
          leaveTypes={leaveTypes}
          leaveList={leaveList}
          setEditData={setEditData}
          setIschange={setIschange}
          ischange={ischange}
        />
      )}
      <LeaveTable handleEdit={handleEdit} ischange={ischange} />
    </>
  );
};

export default LeavePage;
